import { painSchema } from '../validations/pain';
import { baseBloodPressureEntry, baseBloodSugar, baseO2, basePulse, baseRespiration, baseTemperature } from '../validations/shared/vitals';
const bpEntryShape = baseBloodPressureEntry.shape;
const pulseShape = basePulse.shape;
const respirationShape = baseRespiration.shape;
const temperatureShape = baseTemperature.shape;
const o2Shape = baseO2.shape;
const bloodSugarShape = baseBloodSugar.shape;
const painEntryShape = painSchema.shape;
export const bpEntryFields = [
    { key: 'systolic', field: bpEntryShape.systolic },
    { key: 'diastolic', field: bpEntryShape.diastolic },
    { key: 'position', field: bpEntryShape.position },
    { key: 'arm', field: bpEntryShape.arm },
    { key: 'option', field: bpEntryShape.option },
];
export const pulseFields = [
    { key: 'pulse', field: pulseShape.pulse },
    { key: 'pulseApical', field: pulseShape.pulseApical },
    { key: 'pulseReg', field: pulseShape.pulseReg },
];
export const respirationFields = [
    { key: 'resp', field: respirationShape.resp },
    { key: 'effort', field: respirationShape.effort },
    { key: 'respReg', field: respirationShape.respReg },
];
export const temperatureFields = [
    { key: 'temp', field: temperatureShape.temp },
    { key: 'via', field: temperatureShape.via },
];
export const o2Fields = [
    { key: 'o2Sat', field: o2Shape.o2Sat },
    { key: 'flow', field: o2Shape.flow },
    { key: 'lpm', field: o2Shape.lpm },
    { key: 'via', field: o2Shape.via },
    { key: 'viaOther', field: o2Shape.viaOther },
];
export const bloodSugarFields = [
    { key: 'fasting', field: bloodSugarShape.fasting },
    { key: 'random', field: bloodSugarShape.random },
    { key: 'preMeal', field: bloodSugarShape.preMeal },
    { key: 'postMeal', field: bloodSugarShape.postMeal },
    { key: 'bedtime', field: bloodSugarShape.bedtime },
    { key: 'timeSinceLastMeal', field: bloodSugarShape.timeSinceLastMeal },
];
export const painEntryFields = [
    { key: 'location', field: painEntryShape.location },
    { key: 'level', field: painEntryShape.level },
    { key: 'character', field: painEntryShape.character },
    { key: 'onsetDuration', field: painEntryShape.onsetDuration },
    { key: 'relievingAggravating', field: painEntryShape.relievingAggravating },
    { key: 'treatment', field: painEntryShape.treatment },
    { key: 'outcome', field: painEntryShape.outcome },
];
